export * from './shared-table';
